<div class="more-info-header">
  <h1 mat-dialog-title class="more-info-title">{{ data.title }}</h1>

  <button type="button"
          class="more-info-close"
          aria-label="Close"
          data-testid="system-notice-more-info-close"
          (click)="close()">
    <i class="icon-x icon-text-blue"></i>
  </button>
</div>

<mat-dialog-content class="dialog-scroll-shadow">
  <div class="more-info-body" [innerHTML]="safeHtml" appInAppLinks></div>

  @if (data.files.length) {
    <div class="more-info-files">
      <div class="more-info-files__label" rtI18n>Attachments</div>

      <div class="more-info-files__chips">
        @for (file of data.files; track file.Id) {
          <a class="file-chip"
             target="_blank"
             rel="noopener noreferrer"
             [href]="fileUrl(file)"
             [attr.download]="file.FileName"
             [attr.title]="fileLabel(file)"
             [attr.data-testid]="'system-notice-file-' + file.Id">
            <i class="icon-download icon-action-blue"></i>
            <span class="file-chip__name">{{ fileLabel(file) }}</span>
            @if (file.Extension) {
              <span class="file-chip__ext">{{ file.Extension }}</span>
            }
          </a>
        }
      </div>
    </div>
  }

  @if (data.allowFeedback) {
    <div class="more-info-feedback">
      <div class="more-info-feedback__label" rtI18n>Submit Feedback</div>

      <mat-form-field appearance="outline" class="more-info-feedback__field">
        <mat-label rtI18n>Feedback</mat-label>
        <textarea matInput
                  rows="4"
                  name="feedback"
                  data-testid="system-notice-feedback"
                  [maxlength]="FEEDBACK_MAX_LENGTH"
                  [(ngModel)]="feedback"></textarea>
        <mat-hint align="end" rtI18n [rtI18nParams]="{ count: charsRemaining }">[[count]] characters remaining</mat-hint>
      </mat-form-field>

      <div class="more-info-feedback__actions">
        <div class="more-info-note" rtI18n>Submitting also dismisses this notice.</div>

        <button type="button"
                class="btn btn-primary"
                data-testid="system-notice-feedback-submit"
                [disabled]="!feedback.trim() || isSubmitting"
                (click)="submit()">
          @if (isSubmitting) { <span rtI18n>Submitting...</span> } @else { <span rtI18n>Submit</span> }
        </button>
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button"
          class="btn btn-secondary"
          data-testid="system-notice-dismiss-from-panel"
          [disabled]="isSubmitting"
          (click)="dismissNotice()"
          rtI18n>Dismiss</button>
</mat-dialog-actions>
